import React, { useEffect, useState } from "react";
import "./Product_Listing_Page.css";
import All_Vegitables_category_slider from "./all_vegitables_category_slider/All_Vegitables_Category_Slider";

import { Nav, Tab } from "react-bootstrap";
import Top_Filter_Div from "./top_filter_div/Top_Filter_Div";
import Product_Info_Grid_View from "../common_components/product_info_grid_view/Product_Info_Grid_View";
import Shop_Banner from "../shop/shop_banner/Shop_Banner";
import Product_Info_List_View from "../common_components/product_info_list_view/Product_Info_List_View";
import { useDispatch, useSelector } from "react-redux";
import {
  getAllCategories,
  getAllChildCategory,
} from "../../features/master/masterSlice";
import { getAllProducts } from "../../features/products/productsSlice";
import { useLocation, useParams } from "react-router-dom";
import All_Vegitables_subCategory_Slider from "./all_vegitables_category_slider/All_Vegitables_subCategory_Slider";
import All_Vegitables_Category_Slider from "./all_vegitables_category_slider/All_Vegitables_Category_Slider";

const All_Product = () => {
  const [selectedOption, setSelectedOption] = useState(null);
  const location = useLocation();
  const [subCategoryId, setSubCategoryId] = useState(null);
  const searchParams = new URLSearchParams(location.search);
  const categoryName = searchParams.get("category_name");
  const subcategory_id = searchParams.get("sub_category_id");
  const categoryImage = searchParams.get("category_image");
  const subcategoryname = searchParams.get("subcategory_name");

  const { id } = useParams();
  const dispatch = useDispatch();
  const queryParams = new URLSearchParams(location.search);
  const searchValue = queryParams.get("search");
  useEffect(() => {
    setSubCategoryId(id);
    dispatch(
      getAllProducts({
        name: searchValue,
        // category_id: id,
        // subcategory_id: id,
        // childcategory_id: id,
        priceOrder: selectedOption || "",
      })
    );
  }, [dispatch, searchValue]);
  const allProducts = useSelector((state) => state.product.allProducts);
  useEffect(() => {
    dispatch(
      getAllProducts({
        name: searchValue,
        // category_id: id,
        // subcategory_id: subCategoryId,
        // childcategory_id: subCategoryId,
        priceOrder: selectedOption || "",
      })
    );
  }, [dispatch, selectedOption, searchValue]);

  const childcategoriesData = useSelector(
    (state) => state.master.childcategories
  );

  useEffect(() => {
    dispatch(getAllChildCategory(subcategory_id));
  }, [dispatch, id]);

  return (
    <section className="Product_Listing_Page">
      <Tab.Container id="left-tabs-example" defaultActiveKey="Grid">
        {/* <Top_Filter_Div
          pageTitle={categoryName}
          subTitle={subcategoryname}
          selectedOption={selectedOption}
          setSelectedOption={setSelectedOption}
        /> */}

        <div className="container">
          {/* <All_Vegitables_Category_Slider
            categoryImage={categoryImage}
            subcategoryname={subcategoryname}
            categoryId={id}
            show={true}
            subcategory_id={id}
            categories={childcategoriesData}
            setSubCategoryId={setSubCategoryId}
            subCategoryId={subCategoryId}
          /> */}

          <Tab.Content className="mt-5">
            <Tab.Pane eventKey="Grid">
              <div className="row">
                {allProducts?.data?.length > 0 ? (
                  allProducts?.data?.map((product) => {
                    return (
                      <div
                        key={product.id}
                        className="col-xl-2 col-lg-3 col-md-4 col-sm-6 col-12 mb-5 custom_col"
                      >
                        <Product_Info_Grid_View product={product} showQty />
                      </div>
                    );
                  })
                ) : (
                  <div
                    style={{
                      textAlign: "center",
                      padding: "20px",
                      fontWeight: "bold",
                      width: "100%",
                    }}
                  >
                    Product Not Available
                  </div>
                )}
              </div>
              <div className="shop_banner_holder">
                <Shop_Banner />
              </div>
            </Tab.Pane>
            <Tab.Pane eventKey="List">
              {allProducts?.data?.length > 0 ? (
                allProducts?.data?.map((product) =>
                  subCategoryId === product?.p_sub_category_id ? (
                    <Product_Info_List_View
                      key={product.id}
                      products={product}
                      showQty
                    />
                  ) : subCategoryId === null ? (
                    <Product_Info_List_View
                      key={product.id}
                      products={product}
                      showQty
                    />
                  ) : null
                )
              ) : (
                <div
                  style={{
                    textAlign: "center",
                    padding: "20px",
                    fontWeight: "bold",
                  }}
                >
                  Product Not Available
                </div>
              )}
            </Tab.Pane>
          </Tab.Content>
        </div>
      </Tab.Container>
    </section>
  );
};

export default All_Product;
